import React from "react";

import ShrinkIcon from "../../icons/arrow-icon";

const ReportItemHeader = ({ title, shrink, setShrink }) => {
  const renderShrinkControl = () => {
    if (setShrink) {
      return (
        <button className="shrink-btn" onClick={() => setShrink(!shrink)}>
          <ShrinkIcon />
        </button>
      );
    }
  };

  return (
    <div className="report-header">
      <div className="title">
        <p>{title}</p>
      </div>
      <div className="controls">{renderShrinkControl()}</div>
    </div>
  );
};

export default ReportItemHeader;
